import type { EmployeeOnboardingStatus, SchedulerOnboardingItems } from '@/onboarding/constants';
import OnboardingState from '@/onboarding/state';

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export const initialState = new OnboardingState();

export const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    setOpenGuideItem(state, action: PayloadAction<SchedulerOnboardingItems | undefined>) {
      return state.withMutations(item => {
        item.set('openGuideItem', action.payload);
      });
    },

    setForceGuideItem(state, action: PayloadAction<SchedulerOnboardingItems | undefined>) {
      return state.withMutations(item => {
        item.set('forceGuideItem', action.payload);
      });
    },

    setBlockGuideItem(state, action: PayloadAction<boolean>) {
      return state.set('blockGuideItem', action.payload);
    },

    setNewlyCreatedShiftId(state, action: PayloadAction<number>) {
      return state.withMutations(item => {
        item.set('newlyCreatedShiftId', action.payload);
      });
    },

    setEmployeeOnboardingStatus(state, action: PayloadAction<EmployeeOnboardingStatus>) {
      return state.withMutations(item => {
        item.set('employeeOnboardingStatus', action.payload);
      });
    },
  },
});

export const {
  setOpenGuideItem,
  setNewlyCreatedShiftId,
  setForceGuideItem,
  setBlockGuideItem,
  setEmployeeOnboardingStatus,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
